import _regeneratorRuntime from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import axios from 'axios';
export function fetchAllFromAPI(_x, _x2) {
  return _fetchAllFromAPI.apply(this, arguments);
}

function _fetchAllFromAPI() {
  _fetchAllFromAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, force) {
    var commit, state, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, state = _ref.state;

            if (!(force || !state.expires || state.expires < Date.now())) {
              _context.next = 9;
              break;
            }

            _context.next = 4;
            return axios.get('/affiliates');

          case 4:
            response = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 9;
              break;
            }

            _context.next = 8;
            return commit('setAll', response.data);

          case 8:
            commit('updateLifetime');

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchAllFromAPI.apply(this, arguments);
}

export function updateCurrent(_x3, _x4) {
  return _updateCurrent.apply(this, arguments);
}

function _updateCurrent() {
  _updateCurrent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, payload) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            commit('updateCurrent', payload);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateCurrent.apply(this, arguments);
}

export function fetchDistancesFromAPI(_x5, _x6) {
  return _fetchDistancesFromAPI.apply(this, arguments);
}

function _fetchDistancesFromAPI() {
  _fetchDistancesFromAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, payload) {
    var commit, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.next = 3;
            return axios.get("/distance/".concat(payload.latitude, "/").concat(payload.longitude));

          case 3:
            response = _context3.sent;

            if (!(response.status === 200)) {
              _context3.next = 7;
              break;
            }

            _context3.next = 7;
            return commit('setAllDistances', response.data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchDistancesFromAPI.apply(this, arguments);
}

export function fetchSingleAffiliateDistanceFromAPI(_x7, _x8) {
  return _fetchSingleAffiliateDistanceFromAPI.apply(this, arguments);
}

function _fetchSingleAffiliateDistanceFromAPI() {
  _fetchSingleAffiliateDistanceFromAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, payload) {
    var commit, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            _context4.next = 3;
            return axios.get("/affiliates/".concat(payload.id, "/distance/").concat(payload.position.latitude, "/").concat(payload.position.longitude));

          case 3:
            response = _context4.sent;

            if (!(response.status === 200)) {
              _context4.next = 7;
              break;
            }

            _context4.next = 7;
            return commit('setSingleDistance', response.data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchSingleAffiliateDistanceFromAPI.apply(this, arguments);
}

export function updateCurrentDistance(_x9, _x10) {
  return _updateCurrentDistance.apply(this, arguments);
}

function _updateCurrentDistance() {
  _updateCurrentDistance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, payload) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            commit('updateCurrentDistance', payload);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateCurrentDistance.apply(this, arguments);
}